export const articleList = [
  {
    id: "season-watch-2026-autumn",
    title: "秋番观察：这个季度值得留意的五部作品",
    category: "season",
    categoryName: "新番速递",
    author: "编辑部 · 林间",
    date: "2026-09-28",
    updated: "2026-09-30",
    readMinutes: 8,
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20style%20illustration%20of%20a%20stack%20of%20anime%20season%20posters%20and%20a%20calendar%20on%20a%20desk%20with%20warm%20lamp%20light%2C%20cozy%20creative%20workspace%2C%20soft%20cream%20and%20amber%20tones%2C%20clean%20minimal%20composition%2C%20landscape&width=1200&height=675&seq=article-01&orientation=landscape",
    excerpt:
      "换季的时候最容易挑花眼。这篇不排座次，只按“你想被哪种情绪陪伴”来分组，帮你从秋季新番里挑出真正合适的几部。",
    tags: ["新番", "季度观察", "选择建议"],
    sections: [
      {
        heading: "先说清楚：这份观察不排名",
        paragraphs: [
          "每个季度新番一上线，最先出现的往往是各种榜单。但榜单解决的是“别人觉得好”，而不是“今晚适合你”。所以这篇观察换了个思路：先分情绪场景，再谈作品。",
          "我们把秋季新番粗分成五类情绪需求——燃、静、谜、暖、想。你只需要先问自己现在想要哪一种，再往下看对应的作品即可。",
        ],
      },
      {
        heading: "想要被点燃：热血冒险类",
        paragraphs: [
          "这一季的热血作品有一个共同点：它们都在谈“重新开始”。主角多数不是天才，而是被迫回到起点的普通人，这让成长的每一小步都更有重量。",
          "如果你最近状态偏低、需要一点推力，从这类作品入门会比较合适。它们的节奏偏快，单集情绪浓度高，适合每天睡前看一集。",
        ],
        list: [
          "适合场景：加班后的深夜，想找回一点干劲",
          "观看建议：连续看两到三集，情绪连贯性更好",
        ],
      },
      {
        heading: "想要安静：治愈日常类",
        paragraphs: [
          "治愈系这一季继续走“低事件”路线：几乎没有大的转折，靠生活细节撑起整部作品。它不适合一口气刷完，更适合当作一天收尾的固定仪式。",
          "判断一部治愈番是否适合自己，可以看它第一集的“留白”多不多。留白多，说明它更愿意把理解的空间交给观众。",
        ],
        quote: "如果你在找“看完不会更累”的作品，这一组值得优先试试。",
      },
      {
        heading: "把选择权交回给你",
        paragraphs: [
          "无论榜单怎么排，最终陪伴你的还是你自己的感受。建议先各看一集试水，再决定把时间投给哪一部。",
          "后续我们会针对本季作品推出单独的解读与观看指南，如果你想更深入了解某一部，可以在作品库中先看它的资料页。",
        ],
      },
    ],
    related: ["jian-yu-chenguang", "xiari-huisheng", "mianbaodian-wuhou"],
  },
  {
    id: "how-anime-is-made",
    title: "从分镜到成片：一部动画的诞生流程",
    category: "craft",
    categoryName: "制作幕后",
    author: "编辑部 · 周聿",
    date: "2026-09-15",
    updated: "2026-09-18",
    readMinutes: 10,
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20style%20flat%20illustration%20of%20an%20animation%20production%20workflow%2C%20storyboard%20sheets%2C%20colored%20pencils%20and%20a%20monitor%20showing%20sketches%2C%20warm%20studio%20lighting%2C%20cream%20and%20rose%20palette%2C%20clean%20minimal%20composition%2C%20landscape&width=1200&height=675&seq=article-02&orientation=landscape",
    excerpt:
      "很多人以为动画是“画出来”的，其实它更像一条流水线。理解这条流水线，你会看懂很多原本觉得莫名其妙的画面选择。",
    tags: ["制作流程", "分镜", "科普"],
    sections: [
      {
        heading: "第一步永远是文字：企划与剧本",
        paragraphs: [
          "一部动画真正动笔之前，要先确定它想让观众获得什么体验。企划阶段会明确作品的目标时长、播出形式与整体基调，再由编剧把想法写成剧本。",
          "剧本决定的是“发生了什么”，而接下来的分镜才决定“怎么看”。同一段剧情，处理方式不同，观感可能完全相反。",
        ],
      },
      {
        heading: "分镜：把文字翻译成画面语言",
        paragraphs: [
          "分镜是一格一格的手绘草图，标注了机位、景别、动作与台词节奏。它相当于动画的施工图，后面的所有工作都围绕它展开。",
          "你在正片里感受到的“停顿”“镜头悄悄移过去”，往往在这一步就已经定好了。所以分镜师的能力，直接决定了一部作品的呼吸感。",
        ],
        list: [
          "构图与景别：决定观众先看到什么",
          "时间轴：决定一句话留多久",
          "转场设计：决定镜头之间如何连接",
        ],
      },
      {
        heading: "作画与背景：把草图变成可动的画面",
        paragraphs: [
          "原画负责关键动作，动画负责中间帧，背景美术则负责把世界搭起来。三者必须严丝合缝，否则角色会像“贴”在背景上。",
          "这解释了为什么手绘动作场景那么珍贵——它是大量人力与时间堆出来的结果，很难被简单地复制。",
        ],
      },
      {
        heading: "后期与配音：最后一道调味",
        paragraphs: [
          "剪辑会把所有素材拼成最终节奏，音效与配乐负责情绪落点，配音则让角色真正“活”过来。到这一步，作品基本成形。",
          "理解了完整流程，再回头看片尾字幕，你会对那些名字多一分敬意——每一部作品背后，都是几百个人的协作。",
        ],
      },
    ],
    related: ["longwen-jijia", "zhishang-wangguo"],
  },
  {
    id: "healing-anime-rhythm",
    title: "治愈系动画为什么让人放松：节奏与色彩的秘密",
    category: "review",
    categoryName: "作品解析",
    author: "编辑部 · 苏晚",
    date: "2026-08-30",
    updated: "2026-09-02",
    readMinutes: 7,
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20style%20illustration%20of%20a%20calm%20soft%20pastel%20landscape%2C%20gentle%20hills%2C%20a%20small%20figure%20sitting%20under%20a%20tree%2C%20pastel%20pink%20and%20green%20tones%2C%20soothing%20minimal%20composition%2C%20landscape&width=1200&height=675&seq=article-03&orientation=landscape",
    excerpt:
      "“看完不会更累”其实是有方法的。从镜头长度到色彩饱和度，治愈系作品在每一个技术选择上都刻意做了减法。",
    tags: ["治愈系", "色彩", "节奏"],
    sections: [
      {
        heading: "更长的镜头，更慢的信息节奏",
        paragraphs: [
          "治愈类作品普遍使用更长的镜头。当一个画面停留得足够久，大脑就有余地把它“看完”，而不是被下一个信息推着走。",
          "这不是偷懒，而是设计。镜头的长度直接影响了观众的呼吸频率，看久了人会不自觉地放松下来。",
        ],
      },
      {
        heading: "低饱和的色彩，给眼睛留余地",
        paragraphs: [
          "高饱和画面容易让人兴奋，而治愈系往往主动降低饱和度，只在关键情绪点释放少量暖色。这样一收一放，暖色出现时才格外珍贵。",
          "这也是为什么很多治愈番看起来“很清淡”，却一点都不寡淡——它把力气都用在了对的地方。",
        ],
        list: [
          "大面积低饱和背景：稳定情绪基线",
          "少量暖色点缀：标记情绪高点",
          "自然光方向一致：减少视觉噪音",
        ],
      },
      {
        heading: "声音也是“留白”的一部分",
        paragraphs: [
          "治愈系很喜欢环境音：风声、水声、远处的蝉鸣。它们填补了台词之间的空档，又不会强迫你集中注意力。",
          "配乐通常克制，主题旋律在整季里可能只完整出现几次。正因为少，所以一响起就有效。",
        ],
        quote: "治愈不是没有情绪，而是允许情绪慢慢来。",
      },
      {
        heading: "怎么判断一部治愈番适不适合你",
        paragraphs: [
          "看第一集，留意它有没有耐心。如果它愿意花时间让你听懂一个安静的瞬间，那大概率就是你要找的那一类。",
        ],
      },
    ],
    related: ["huaji-jixing", "mianbaodian-wuhou", "shenye-lamian"],
  },
  {
    id: "long-series-pacing",
    title: "长篇连载如何保持节奏：剧情结构入门",
    category: "craft",
    categoryName: "制作幕后",
    author: "编辑部 · 周聿",
    date: "2026-08-12",
    updated: "2026-08-14",
    readMinutes: 9,
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20style%20illustration%20of%20an%20open%20notebook%20with%20a%20hand-drawn%20story%20arc%20curve%20and%20sticky%20notes%2C%20warm%20desk%20lamp%20glow%2C%20cream%20and%20green%20palette%2C%20clean%20minimal%20composition%2C%20landscape&width=1200&height=675&seq=article-04&orientation=landscape",
    excerpt:
      "二十多集的作品最容易“中段垮掉”。这篇拆解长篇叙事的常见结构，教你怎么判断一部作品是不是在拖，以及它拖得值不值。",
    tags: ["叙事结构", "节奏", "长篇"],
    sections: [
      {
        heading: "先分清“慢”和“拖”",
        paragraphs: [
          "慢是刻意的，拖是被迫的。慢的作品会在安静里埋信息，而拖的作品只是把观众的耐心当作缓冲垫。",
          "判断标准很简单：这一段结束后，你对人物或世界的理解有没有变多？如果没有，那它大概率在拖。",
        ],
      },
      {
        heading: "三幕结构在长篇里的变体",
        paragraphs: [
          "经典的三幕结构（建立、对抗、解决）在长篇里会被拉长并重复嵌套。每一段小单元其实也是一个微型三幕，这让作品可以持续提供“完成感”。",
          "好的长篇会在单元之间放置主线伏笔，让你在小高潮之后依然有往下看的动力。",
        ],
        list: [
          "开场：建立规则与人物动机",
          "中段：反复升级冲突，穿插支线",
          "收束：回收伏笔，回应最初的动机",
        ],
      },
      {
        heading: "用“代价”衡量节奏是否有效",
        paragraphs: [
          "情节推进是否有力，关键看代价。如果角色可以无成本地解决问题，观众就很难投入；一旦付出代价，哪怕是小代价，故事也会变得可信。",
        ],
        quote: "节奏的本质不是快慢，而是每一集有没有让局势发生不可逆的变化。",
      },
      {
        heading: "给追长篇的实用建议",
        paragraphs: [
          "长篇不建议一口气刷完。每看完一个单元就停下来回想一下关键变化，会明显提升观感。",
          "如果中段实在提不起劲，可以试试先跳看主线相关的几集，再回头补支线。",
        ],
      },
    ],
    related: ["xinghai-lieche", "longwen-jijia", "quan-yu-xinghuo"],
  },
  {
    id: "anime-music-guide",
    title: "动画配乐入门：如何听懂一段旋律的情绪",
    category: "review",
    categoryName: "作品解析",
    author: "编辑部 · 苏晚",
    date: "2026-07-25",
    updated: "2026-07-27",
    readMinutes: 6,
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20style%20illustration%20of%20sheet%20music%2C%20headphones%20and%20a%20piano%20keyboard%20close%20up%2C%20warm%20ambient%20light%2C%20soft%20gold%20and%20cream%20palette%2C%20clean%20minimal%20composition%2C%20landscape&width=1200&height=675&seq=article-05&orientation=landscape",
    excerpt:
      "为什么同一段画面，换个配乐就完全不一样？这篇用最少的术语，带你去听配乐到底在做什么。",
    tags: ["配乐", "声音设计", "入门"],
    sections: [
      {
        heading: "配乐不负责“描述”，它负责“引导”",
        paragraphs: [
          "画面已经告诉你发生了什么，配乐要做的是告诉你“该怎么感觉”。它不描述事件，而是调整你的情绪位置。",
          "所以好的配乐往往不抢戏。你甚至不会注意到它，但把音量关掉，画面立刻会变得干瘪。",
        ],
      },
      {
        heading: "三个最常用的手法",
        paragraphs: [
          "不需要懂乐理也能听出差别。留意乐器数量、音区高低和节奏密度，基本就能判断一段配乐想干什么。",
        ],
        list: [
          "加乐器：情绪升级，从单人乐器走向整个乐团",
          "提音区：紧张或明亮，弦乐高音常用来制造挤压感",
          "改节奏：加快代表紧迫，放慢代表沉淀",
        ],
      },
      {
        heading: "主题旋律为什么要“重复”",
        paragraphs: [
          "角色或作品的主题旋律会被反复使用，但每次编曲不同。这种“熟悉的陌生感”能让观众在瞬间回想起之前的情绪。",
        ],
        quote: "配乐最厉害的时候，是它让你觉得这段记忆本来就是有旋律的。",
      },
      {
        heading: "自己怎么练耳朵",
        paragraphs: [
          "下次看动画时，试着只听声音闭上眼睛。你会发现，一部作品的配乐是可以独立成篇的。",
          "也可以找原声带单独听一遍，再回想它出现在哪个场景，听觉记忆会被强化很多。",
        ],
      },
    ],
    related: ["huaji-jixing", "yueding-zhonglou"],
  },
  {
    id: "weekly-watchlist-plan",
    title: "追番时间管理：如何安排每周的观看清单",
    category: "guide",
    categoryName: "观看指南",
    author: "编辑部 · 林间",
    date: "2026-07-08",
    updated: "2026-07-10",
    readMinutes: 5,
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20style%20illustration%20of%20a%20weekly%20planner%20with%20colorful%20sticky%20notes%20and%20a%20cup%20of%20tea%20on%20a%20wooden%20desk%2C%20warm%20morning%20light%2C%20cream%20and%20rose%20palette%2C%20clean%20minimal%20composition%2C%20landscape&width=1200&height=675&seq=article-06&orientation=landscape",
    excerpt:
      "追番不是越多越好。用一套简单的排序方法，把有限的休息时间留给真正想看的作品，而不是被“没看完”的焦虑追着跑。",
    tags: ["追番", "时间管理", "习惯"],
    sections: [
      {
        heading: "先承认时间有限",
        paragraphs: [
          "一季新番动辄三四十部，但大部分人的闲暇是固定的。与其列一个巨大的清单，不如先算清楚每周真正能看几集。",
          "把“能看的集数”当作预算，然后再分配。这个顺序很重要，它能让你的选择变得轻松。",
        ],
      },
      {
        heading: "用三档优先级别分",
        paragraphs: [
          "把想看的作品分成“必追”“顺便”“待定”三档。必追的固定时间看，顺便的有空看，待定的先放一放。",
          "这样做的意义是：即使某周很忙，你也不会觉得欠了什么，因为待定档本来就是允许放弃的。",
        ],
        list: [
          "必追：每周固定时段，优先保证",
          "顺便：通勤或吃饭时看，不追求连续",
          "待定：季末再决定要不要补",
        ],
      },
      {
        heading: "给每一部作品留“退出”选项",
        paragraphs: [
          "看三集还提不起兴趣的作品，允许自己放下。追番是休息，不是任务。主动退出不是半途而废，而是把时间留给更合适的作品。",
        ],
        quote: "看动画是为了开心，不是为了完成任务清单。",
      },
      {
        heading: "让清单服务于你，而不是相反",
        paragraphs: [
          "定期回顾一下：过去一个月里，哪些作品看完是愉悦的？把资源向那一类倾斜，你的观看体验会越来越好。",
        ],
      },
    ],
    related: ["shenye-lamian", "mianbaodian-wuhou", "quan-yu-xinghuo"],
  },
];